import React from 'react';
import type { ShotFeed } from '../../stores/types/shots';
import classNames from 'classnames';
import Icon, { COLORS, ICONS } from './icon';

interface MyProps {
    isCurrentActiveShot: boolean;
    mediaOnCanvasIds: (string | number)[];
    shotFeed: ShotFeed;
}

export default function AudioOnlyFeedsIcon(props: MyProps) {
    const {
        isCurrentActiveShot,
        mediaOnCanvasIds,
        shotFeed,
    } = props;

    return (
        <div className={classNames(
            'aof-icon-wrapper',
            {
                'in-shot': isCurrentActiveShot || (
                    mediaOnCanvasIds.includes(shotFeed?.media ?? 0)
                    || mediaOnCanvasIds.includes(shotFeed?.screenshare ?? 0)
                    || mediaOnCanvasIds.includes(shotFeed?.presenter ?? 0)
                ),
            },
        )}>
            <Icon
                name={ICONS.MUSIC_NOTE_NEW}
                size={13}
                color={isCurrentActiveShot || (
                    mediaOnCanvasIds.includes(shotFeed?.media ?? 0)
                    || mediaOnCanvasIds.includes(shotFeed?.screenshare ?? 0)
                    || mediaOnCanvasIds.includes(shotFeed?.presenter ?? 0)
                )
                    ? COLORS.BLACK
                    : COLORS.WHITE}
            />
        </div>
    );
}